<template>
	<div class="page"> 
		<!-- <div class="banner-code" v-if="codeBtn" >
			<img src="../assets/images/banner.jpg" width="100%" alt="" @click="showCode">
		</div> -->
		<!-- <div style="font-size: 0;position: relative;z-index: 10000"><a href="note.html" target="_blank"><img src="../assets/b.jpg" width="100%" alt=""></a></div> -->
		<!-- <div class="nate">
			<div class="device">
				<div class="navTitle marquee">
				  	<div class="get-marquee-width">
				    	<div class="marquee-move">
				     		<span>В декабре Google play store была обновлена, и теперь обладатели магнитолы с параметрами 1+16 4G каждый раз при скачивании приложений получают предупреждение о нехватке памяти. На самом деле памяти достаточно, просто Google play store не видит все разделы жесткого диска устройства. Сейчас наши специалисты уже разрабатывают обновление, которое решит эту проблему. Когда оно будет готово, мы опубликуем на этой странице ссылку для скачивания.</span>
				    	</div>
				  	</div>
				</div>
				<div class="notice"></div>
				<div class="btn" @click="can">去看看</div>
			</div>
		</div> -->
		<div class="rightNav___2EmD7"><p :class="active?'active btn___26Ys_':'btn___26Ys_' " @click="menu()"></p></div>
		<div :class="active?'menuMask___1kW8n active':'menuMask___1kW8n'" @click="menu()"></div>
		<div :class="active?'pageContent___BhUpA active':'pageContent___BhUpA'" @click="menu()">
			<div>
				<p class="title" v-for="item,index in data" :key="index">
					{{item.title}}
					<span :href="i.url" @click="open(i)" target="_blank" v-for="i,n in item.list" :key="n">{{i.title}}</span>
				</p>
				<!-- <p>Rio 3</p>
				<p>Rio 4</p>
				<p class="title">TOYOTA</p>
				<p>Corolla</p>
				<p>Rav4</p>
				<p class="title">Hyundai</p>
				<p>Solaris 1</p>
				<p>Solaris 2</p>
				<p>Elantra Avante</p>
				<p>Creta</p>
				<p class="title">Nissan</p>
				<p>X-Trail T32</p>
				<p>Volkswagen</p>
				<p>POLO</p> -->
			</div>
		</div>
		<div class="page-content">
			<div class="message-content">
				<!-- <img src="../assets/text.png" alt=""> -->
				<div class="btn-low">
					<!-- <p class="show-video" @click="loadLiner('4g')">4G版线路定义</p> -->
					<p class="show-video" @click="loadLin2('wifi')">Видео по настройке CANBUS</p>
					<!-- <p class="show-video" @click="loadLin()"> О винтовых отверстиях магнитолы</p> -->
				</div>
				<div class="btn-low">
					<!-- <p class="show-video" @click="loadLiner('4g')">4G版线路定义</p> -->
					<!-- <p class="show-video" @click="loadLin2('wifi')">Видео по настройке CANBUS</p> -->
					<p class="show-video" @click="loadLin()"> О винтовых отверстиях магнитолы</p>
				</div>
				<div class="btn-low">
					<button class="custom-primary-black" @click="load()">Часто задаваемые вопросы</button>
					<button class="custom-primary-black" @click="menu">Видео по установке</button>
					<button class="custom-primary-black" @click="W('wifi')">Схема подключения проводов</button>
					<button class="custom-primary-black" @click="down('wifi')">Скачать последнее обновление</button>
					<!-- <button class="custom-primary-black" @click="complaint">Консультация специальста компании</button> -->
				</div>
			</div>
		</div>

		<div class="modal" v-if="isModal">
			<div class="modal-inner">
				<div class="modal-title">
					Teyes 
				</div>
				<div class="modal-text">coming soon</div>
			</div>
			<div class="modal-buttons modal-buttons-1 ">
				<span class="modal-button modal-button-bold" @click="hideModal">OK</span>
			</div>
		</div>
		
		<div class="modal-code" v-if="isCode" @click="hideCode">
			
			<div class="text">
				<img src="../assets/code.png" alt="" width="100%">
					<p>长按屏幕识别二维码</p>
					<p>关注“天之眼”公众号</p>
			</div>
				
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				data:[],
				active:false,
				isModal:false,
				codeBtn:window.location.hash.indexOf("type=default")>-1?false:true,
				isCode:false
			}
		},
		created(){
			wx.ready(function() {

                var message ={
                    title: 'Teyes CC', // 分享标题
                    desc: 'Teyes CC', // 分享描述
                    link: 'http://cc.teyes.ru/#/home', // 分享链接
                    imgUrl: 'http://cc.teyes.ru/static/images/300x300.jpg', // 分享图标
                }

                wx.onMenuShareAppMessage(message);
                wx.onMenuShareTimeline(message);
            })
            console.log(process.env.NODE_ENV=='development')
            this.getData()
		},
	  	methods:{
	  		getData(){
	  			var that = this
	  			var server = process.env.NODE_ENV=='development'?'http://192.168.1.103/cc_ru/data.php':'http://cc.teyes.ru/data.php'
	  			var xhr = new XMLHttpRequest();            
			    xhr.open('GET', server, true);
			    xhr.onreadystatechange = function() {
			      // readyState == 4说明请求已完成
			      if (xhr.readyState == 4 && xhr.status == 200 || xhr.status == 304) { 
			        // 从服务器获得数据
			        var data = JSON.parse(xhr.responseText) 
			        console.log(data)
			        that.data = data
			      }
			    };
			    xhr.send();
	  		},
	  		down(){
            	// this.$router.push({ path: '/down' })
            	window.location.href = 'http://cc.teyes.ru/down.html'
	  		},	
	  		menu(){
	  			this.active=!this.active
	  		},
	  		showCode(){
	  			this.isCode = true
	  		},
	  		showPlugin(){
	  			this.isModal = true
	  		},
	  		hideCode(e){
	  			if(e.target.className=='modal-code' ){
	  				this.isCode = false
	  			}
	  		},
	  		hideModal(){
	  			this.isModal = false
	  		},
	  		loadLin2(){
            	this.$router.push({ path: '/car' })
	  		},
	  		loadLiner(options){
	  			if(options=='4g'){
	  				window.location.href = 'http://cc.teyes.cn/map/'
	  			}
	  			if(options=='wifi'){
	  				window.location.href = 'http://cc.teyes.cn/wifi/'
	  			}
	  		},
	  		open(item){
	  			console.log(item)
	  			if(item.url){
	  				window.open(item.url)
	  				
	  			}else{
	  				this.isModal = true

	  			}
	  		},
	  		faq(){
	  			window.location.href = 'http://faq.teyes.ru/#/home?type=cc'
	  		},
	  		complaint(){
	  			window.location.href = 'http://feed.teyes.ru/complaint.html?type=cc'
	  		},
	  		W(){
	  			window.location.href = 'http://cc.teyes.ru/map/'

            	// this.$router.push({ path: '/w' })

	  		},
	  		loadLin(){
            	this.$router.push({ path: '/pic' })

	  		},
	  		product(){
            	this.$router.push({ path: '/main' })
	  		},
	  		load(){
            	this.$router.push({ path: '/book' })
	  		},
	  		can(){
            	this.$router.push({ path: '/can' })
	  		},
	  		loadView(){
	  			window.location.href = 'http://feed.teyes.ru/feedback.html?type=cc'
	  		}
	  	}
	}
</script>
<style lang="less" scoped>
.pageContent___BhUpA {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    
    // padding-top: 60px;
    z-index: -100;
    &.active{
    	z-index: 100;
    }
    >div{
    	width: 50%;
    	padding: 60px 30px;
    	position: absolute;
    	right: 0;
    	bottom: 0;
    	top: 0;
    	overflow: auto;
   	 	-webkit-overflow-scrolling: touch;
    	background-color: #fff;
    	p{
    		// padding: 5px 10px;
    		font-size: 14px;
    		margin-left: 10px;
    		padding: 5px 0; 
    		text-transform: uppercase;
    	}
    	span{
    		display: block;
    		color: #000;
    		text-decoration: none;
    		// padding: 5px 10px;
    		font-size: 14px;
    		margin-left: 10px;
    		padding: 8px 0; 
    		text-transform: uppercase;
    	}
    	.title{
    		margin-top: 20px;
    		margin-bottom: 18px;
    		margin-left: 0;
    		font-size: 16px;
    	}
    }
}
.menuMask___1kW8n.active {
    width: 100%;
}
.menuMask___1kW8n {
    position: absolute;
    z-index: 10;
    left: 0%;
    width: 0;
    bottom: 0;
    top: 0px;
    overflow: hidden;
    background-color: rgba(34, 34, 34, 0.25);
    -webkit-transition: opacity 300ms ease-in-out;
    transition: opacity 300ms ease-in-out;
}
.rightNav___2EmD7 {
    position: absolute;
    top: 33px;
    right: 0;
    z-index: 120;
    padding-right: 25px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
}
.rightNav___2EmD7 .btn___26Ys_ {
    display: block;
    width: 25px;
    height: 3px;
    line-height: 0;
    border-radius: 4px;
    background-color: #fff;
}
.rightNav___2EmD7 .btn___26Ys_:before {
    content: '';
    display: block;
    width: 25px;
    height: 3px;
    border-radius: 4px;
    background-color: #fff;
    margin-top: -9px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
.rightNav___2EmD7 .btn___26Ys_:after {
    content: '';
    display: block;
    width: 25px;
    height: 3px;
    border-radius: 4px;
    background-color: #fff;
    margin-top: 15px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}
.rightNav___2EmD7 .btn___26Ys_.active {
    background-color: transparent;
}

.rightNav___2EmD7 .btn___26Ys_ {
    display: block;
    width: 25px;
    height: 3px;
    line-height: 0;
    border-radius: 4px;
    background-color: #fff;
}
.rightNav___2EmD7 .btn___26Ys_.active:before {
    -webkit-transform: rotate(45deg) translate(5px, 5px);
    transform: rotate(45deg) translate(5px, 5px);
    background-color: #222;
}
.rightNav___2EmD7 .btn___26Ys_.active:after {
    -webkit-transform: rotate(-45deg) translate(7px, -8px);
    transform: rotate(-45deg) translate(7px, -8px);
    background-color: #222;
}
/* 假设.device的宽度是设备的宽度*/
	.device{
		max-width: 750px;
	  	width:100%;
	  	background-color: rgba(0,0,0,0.5);
	  	color: #fff;
	  	.btn{
	    	position: absolute;
	    	right: 0;
	    	top: 0;
	    	line-height: 40px;
	    	padding:0 10px;
	    	color: #0174cd;
	    	z-index: 1000;
	    }
	    .notice{
	    	position: absolute;
	    	left: 6px;
	    	top:54px;
	    	background-image: url(../assets/notice.png);
	    	background-size: 18px auto;
	    	background-repeat: no-repeat;
	    	background-position: center;
	    	width: 20px;
	    	height: 24px;
	    	z-index: 1000;
	    }
	}
	.marquee{
		margin:0 30px;
	    position: relative;
	    width: calc(~'100% - 88px');
	    overflow: hidden;
	    height: 40px;
	    line-height: 40px;
	    
	}
	.marquee > .get-marquee-width{
	    position: relative;
	}
	.marquee> .get-marquee-width > .marquee-move{
	    -webkit-animation:  marquee 20s linear 1s infinite;
	    -o-animation:  marquee 20s linear 1s infinite;
	    animation:  marquee 20s linear 1s infinite;
	    position: absolute;
	    width:100%;
	    padding-left: 5px;
	    white-space: nowrap; -webkit-transform: translate3d(0, 0, 0);
	   -moz-transform: translate3d(0, 0, 0);
	   -ms-transform: translate3d(0, 0, 0);
	   transform: translate3d(0, 0, 0);

	}

	@-webkit-keyframes marquee {
	    0% { left: 0; }
	    5%{left: 0;}
	    100% { left: -200%; }
	}
	@-moz-keyframes marquee {
	    0% { left: 0; }
	    5%{left: 0;}
	    100% { left: -200%; }
	}
	@-o-keyframes marquee {
	    0% { left: 0; }
	    5%{left: 0;}
	    100% { left: -200%; }
	}
	@keyframes marquee {
	    0% { left: 0; }
	    5%{left: 0;}
	    100% { left: -200%; }
	}
	.banner-code{
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		right: 0;
	}
	.modal-code{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 11;
		display: flex;
		background-color: rgba(0, 0, 0, 0.8);
		align-items: center;
    	justify-content: center;
		.text{
			text-align: center;
			color: #fff;
		}
		p{
			font-size: 14px;
			margin-top: 10px;
			&:last-child{
				font-weight: bold;
			}
		}
		img{
			width: 150px;
			margin-bottom: 10px;
		}
	}
	.page{
		position: relative;
		height: 100vh;
		width: 100%;
		overflow: hidden;
		background-color: #000;
		background-image: url(../assets/bg.jpg);
		background-size: 100% auto;
		background-repeat: no-repeat;
		background-position: top center;
		.page-content{
			width: 100%;
			position: absolute;
			top: 0;
			left: 0px;
			right: 0;
			bottom: 0;
			font-size: 14px;
			.message-content{
				position: absolute;
				bottom: 10vh;
				left:0;
				right: 0;
				text-align: center;
				img{
					width: 50%;
				}
				.btn-low{
					margin: 20px;
					p{
						display: inline-block;
						&:first-child{
							margin-right: 10px;
						}
					}
					button{
						position: relative;
					    display: block;
					    margin-left: auto;
					    margin-right: auto;
					    padding-left: 14px;
					    padding-right: 14px;
					    box-sizing: border-box;
					    font-size: 14px;
					    text-align: center;
					    text-decoration: none;
					    color: #fff;
					    line-height: 2.33333333;
					    border-radius: 5px;
					    -webkit-tap-highlight-color: rgba(0,0,0,0);
					    overflow: hidden;
					    width: 100%;
						max-width: 400px;
						outline: none;
					}
					button+button{
						margin-top: 15px;
					}
				}
				.show-video{
					color: #0174cd;
					line-height: 12px;
					border-bottom: 1px solid #0174cd;
					display: inline-block;
					// margin-bottom: 20px
				}
				.custom-primary-black{
					border-radius: 6px!important;
					border-color: #262626!important;
					color: #fff!important;
					background-color: #262626;
					font-size: 14px;
					line-height: 36px;
					&:active {
						border-color: #262626!important;
						background-color: #262626;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue